<template>
	<div>
		<case-form :schema="schemaPolitical" class="mt6" />
		<div class="fs4 fw7 lh125 mt6">
			If “Yes,” please provide title/rank, details of duties, time period
			position was held, and nature of relationship with the PEP.
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaPEP(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schema" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			What position was held by the person who is or was politically exposed?
		</div>
		<case-form :schema="schemaPosition" />

		<div class="xs-12 fs4 fw7 mb2 mt6">
			What is the relationship to this individual?
		</div>
		<case-form :schema="schemaRelationship" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaPolitical() {
			return [
				{
					label: `Are you or a close relative a Politically Exposed Person (PEP) or have you or any close relative (living or deceased), ever been
a PEP, member of any uniformed forces, labour union official, or journalist? (Close relative means, spouse, civil union spouse or
common-law partner, children or step-children, siblings or half-siblings or step-siblings, biological or adoptive or step-parent
of the Client, biological or adoptive or step-parent of spouse, civil union spouse or common-law partner.)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isOrIsRelativeOfPEP`,
					props: {
						suggest: {
							typeIncludes: `isOrIsRelativeOfPEP`
						},
						createOptions: {
							type: `isOrIsRelativeOfPEP`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schema() {
			return [
				{
					label: `Have you or any close relative ever held a senior position in a government, political party, military tribunal or government-owned corporation?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isOrIsRelativeOfPEP`,
					props: {
						suggest: {
							typeIncludes: `isOrIsRelativeOfPEP`
						},
						createOptions: {
							type: `isOrIsRelativeOfPEP`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `What is the name of the person who holds or held the office?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPName`,
					props: {
						suggest: {
							typeIncludes: `PEPName`
						},
						createOptions: {
							type: `PEPName`,
							dataType: "string"
						}
					}
				},
				{
					label: ` In what country is/was the position held?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPCountryHeld`,
					props: {
						suggest: {
							typeIncludes: `PEPCountryHeld`
						},
						createOptions: {
							type: `PEPCountryHeld`,
							dataType: "string"
						}
					}
				},
				{
					label: `Position was held from`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPPositionHeldFrom`,
					props: {
						suggest: {
							typeIncludes: `PEPPositionHeldFrom`
						},
						createOptions: {
							type: `PEPPositionHeldFrom`,
							dataType: "date"
						}
					}
				},
				{
					label: `Position was held to`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPPositionHeldTo`,
					props: {
						suggest: {
							typeIncludes: `PEPPositionHeldTo`
						},
						createOptions: {
							type: `PEPPositionHeldTo`,
							dataType: "date"
						}
					}
				},
				{
					label: `Title of position held`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPTitleOfPosition`,
					props: {
						suggest: {
							typeIncludes: `PEPTitleOfPosition`
						},
						createOptions: {
							type: `PEPTitleOfPosition`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPosition() {
			return [
				{
					label: `Head of state or head of government`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisHeadOfStateOrGovt`,
					props: {
						suggest: {
							typeIncludes: `PEPisHeadOfStateOrGovt`
						},
						createOptions: {
							type: `PEPisHeadOfStateOrGovt`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Head of a government agency`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisHeadOfGovtAgency`,
					props: {
						suggest: {
							typeIncludes: `PEPisHeadOfGovtAgency`
						},
						createOptions: {
							type: `PEPisHeadOfGovtAgency`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Member of the executive council of government or member of a legislature`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisMemberOfCouncilOrLegislature`,
					props: {
						suggest: {
							typeIncludes: `PEPisMemberOfCouncilOrLegislature`
						},
						createOptions: {
							type: `PEPisMemberOfCouncilOrLegislature`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Judge`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisJudge`,
					props: {
						suggest: {
							typeIncludes: `PEPisJudge`
						},
						createOptions: {
							type: `PEPisJudge`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Deputy Minister (or equivalent)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisDeputyMinister`,
					props: {
						suggest: {
							typeIncludes: `PEPisDeputyMinister`
						},
						createOptions: {
							type: `PEPisDeputyMinister`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Leader or president of a political party in a legislature`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisLeaderOrPresidentOfPoliticalParty`,
					props: {
						suggest: {
							typeIncludes: `PEPisLeaderOrPresidentOfPoliticalParty`
						},
						createOptions: {
							type: `PEPisLeaderOrPresidentOfPoliticalParty`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Ambassador or ambassador’s attaché or counsellor`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisAmbassador`,
					props: {
						suggest: {
							typeIncludes: `PEPisAmbassador`
						},
						createOptions: {
							type: `PEPisAmbassador`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Military general (or higher rank)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisMilitaryGeneral`,
					props: {
						suggest: {
							typeIncludes: `PEPisMilitaryGeneral`
						},
						createOptions: {
							type: `PEPisMilitaryGeneral`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `President of a state-owned company or bank`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisPresidentOfCompanyOrBank`,
					props: {
						suggest: {
							typeIncludes: `PEPisPresidentOfCompanyOrBank`
						},
						createOptions: {
							type: `PEPisPresidentOfCompanyOrBank`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Other`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisOthers`,
					props: {
						suggest: {
							typeIncludes: `PEPisOthers`
						},
						createOptions: {
							type: `PEPisOthers`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `(Please identify)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisOthersDetails`,
					props: {
						suggest: {
							typeIncludes: `PEPisOthersDetails`
						},
						createOptions: {
							type: `PEPisOthersDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaRelationship() {
			return [
				{
					label: `Self`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisInsured`,
					props: {
						suggest: {
							typeIncludes: `PEPisInsured`
						},
						createOptions: {
							type: `PEPisInsured`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Mother or Father`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisParent`,
					props: {
						suggest: {
							typeIncludes: `PEPisParent`
						},
						createOptions: {
							type: `PEPisParent`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Spouse or common-law partner`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisPartner`,
					props: {
						suggest: {
							typeIncludes: `PEPisPartner`
						},
						createOptions: {
							type: `PEPisPartner`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Brother, sister, half-brother or half-sister`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisSibling`,
					props: {
						suggest: {
							typeIncludes: `PEPisSibling`
						},
						createOptions: {
							type: `PEPisSibling`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Child`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisChild`,
					props: {
						suggest: {
							typeIncludes: `PEPisChild`
						},
						createOptions: {
							type: `PEPisChild`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Spouse’s or common-law partner’s parent`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPisPartnersParent`,
					props: {
						suggest: {
							typeIncludes: `PEPisPartnersParent`
						},
						createOptions: {
							type: `PEPisPartnersParent`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaPEP(i) {
			return [
				{
					label: `Title/Rank`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0politicalPersonTitleOrRank${i}`,
					props: {
						suggest: {
							typeIncludes: `politicalPersonTitleOrRank${i}`
						},
						createOptions: {
							type: `politicalPersonTitleOrRank${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Details of Duties`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0politicalPersonDuties${i}`,
					props: {
						suggest: {
							typeIncludes: `politicalPersonDuties${i}`
						},
						createOptions: {
							type: `politicalPersonDuties${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Position was held from`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0politicalPersonHeldPositionFrom${i}`,
					props: {
						suggest: {
							typeIncludes: `politicalPersonHeldPositionFrom${i}`
						},
						createOptions: {
							type: `politicalPersonHeldPositionFrom${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Position was held to`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0politicalPersonHeldPositionTo${i}`,
					props: {
						suggest: {
							typeIncludes: `politicalPersonHeldPositionTo${i}`
						},
						createOptions: {
							type: `politicalPersonHeldPositionTo${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Nature of Relationship to PEP`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0relationshipToPEP${i}`,
					props: {
						suggest: {
							typeIncludes: `relationshipToPEP${i}`
						},
						createOptions: {
							type: `relationshipToPEP${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
